import React from 'react';


export const IAM = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/iam.png')} />
    )
};
